import { GetClothingOutput } from './clothing-api.types';

export class Clothing {
  constructor(public getClothingOutput: GetClothingOutput) {}

  static fromResultArray(clothingOutput: GetClothingOutput[]): Clothing[] {
    return clothingOutput.map((cOutput) => new Clothing(cOutput));
  }

  get id() {
    return this.getClothingOutput.id;
  }

  get bezeichnung() {
    return this.getClothingOutput.bezeichnung;
  }

  get kleidergroesse() {
    return this.getClothingOutput.kleidergroesse;
  }

  get kleidergroesseText() {
    return this.getClothingOutput.kleidergroesse_text;
  }

  get kleidungstyp() {
    return this.getClothingOutput.kleidungstyp;
  }

  get geschlecht() {
    return this.getClothingOutput.geschlecht;
  }

  get geschlechtText() {
    return this.getClothingOutput.geschlecht_text;
  }

  get status() {
    return this.getClothingOutput.status;
  }

  get statusText() {
    return this.getClothingOutput.status_text;
  }

  get firmaId() {
    return this.getClothingOutput.firmaId;
  }

  get firma() {
    return this.getClothingOutput.firma;
  }

  get inventarnummer() {
    return this.getClothingOutput.inventarnummer;
  }

  get herstellercode() {
    return this.getClothingOutput.herstellercode;
  }

  get personId() {
    return this.getClothingOutput.personId;
  }

  get bemerkung() {
    return this.getClothingOutput.bemerkung;
  }

  get person() {
    return this.getClothingOutput.person;
  }
}
